export function storeFirstTouchUtm() {
  if (!localStorage.getItem('utm_data')) {
    const params = new URLSearchParams(window.location.search);
    const utm = {
      utm_source: params.get('utm_source'),
      utm_medium: params.get('utm_medium'),
      utm_campaign: params.get('utm_campaign'),
      utm_content: params.get('utm_content'),
      utm_term: params.get('utm_term')
    };

    if (Object.values(utm).some(Boolean)) {
      localStorage.setItem('utm_data', JSON.stringify(utm));
    }
  }
}

export function getUtmData() {
  const utmData = localStorage.getItem('utm_data');
  return utmData ? JSON.parse(utmData) : null;
}
